import axios from 'axios'
import store from './store'
import router from './router'
import { getInstance } from './auth/authWrapper'

const authService = getInstance();

const instance = axios.create({
  headers: {
    Accept: 'application/json'
  }
})
// Add a request interceptor
instance.interceptors.request.use(
  async config => {
    const token = await authService.getTokenSilently();
    
    config.headers.common['Authorization'] = `Bearer ${
      token
    }`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      if (401 === error.response.status) {
        
      }
    }
    return Promise.reject(error)
  }
)

export const HTTP = instance
